/**
 * ═══════════════════════════════════════════════════════════════════════════
 * ALL FACETS REFERENCE - VERSION 5.2 UNIVERSAL
 * ═══════════════════════════════════════════════════════════════════════════
 * 
 * RÈGLE D'OR: N'importe quel facet peut être ajouté à N'IMPORTE QUELLE page.
 * 
 * ┌──────────────────────────────────────────────────────────────────────────┐
 * │  48 sections totales                                                    │
 * │  ├── 38 sections API  (🔌) → DataLoader appelle l'API automatiquement  │
 * │  └── 10 sections sync (📋) → Données depuis infoSource                │
 * │                                                                         │
 * │  Si tu ajoutes 'shopProductGrid' sur HOME:                             │
 * │    → DataLoader: SHOP_USER loader → resolveUserId() → null → skip     │
 * │    → Section: data vide → shouldRenderSection = false → pas affichée   │
 * │                                                                         │
 * │  Si tu ajoutes 'newProducts' sur SHOP_USER:                            │
 * │    → DataLoader: PRODUCTS loader → getProductsF → data OK              │
 * │    → Section: data présente → shouldRenderSection = true → affichée    │
 * │                                                                         │
 * │  Si tu ajoutes 'cartFullLayout' sur HOME:                              │
 * │    → DataLoader: NONE → pas d'API                                      │
 * │    → FACET_SYNC_MAP_: sync infoSource.getCartItems → pageData.cartItems │
 * │    → Section: affichée si panier non vide                              │
 * └──────────────────────────────────────────────────────────────────────────┘
 * 
 * LOADERS disponibles (9):
 *   PRODUCTS        → getProductsF         | Fonctionne partout
 *   LAKAY_USER      → getLakayUser(admin)   | Besoin: infoSource.userAdmin._id
 *   SHOP_USER       → getLakayUser(shop)    | Besoin: userId (prop ou context)
 *   USER_VIEWED     → getUserViewed         | Besoin: viewed IDs (auto-résolu)
 *   ORDERS          → listOrders            | Besoin: token
 *   CATEGORIES      → getCategoriesByID     | Besoin: categoryId
 *   PRODUCT_PREVIEW → getProductPreview     | Besoin: productId
 *   COMMENTS        → commentProduct        | Besoin: productId
 *   SEARCH          → getProductSearch      | Besoin: search (skip si vide)
 *   INVESTMENTS     → API investments       | Catalogue + detail public
 *   JOBS            → API jobs              | Catalogue + detail public
 */

// ─────────────────────────────────────────────────────────────────────────────
// TOUS LES 48 FACETS (sectionIds) DISPONIBLES
// ─────────────────────────────────────────────────────────────────────────────

export const ALL_FACETS = [

    // ═══ PRODUCTS loader (getProductsF) — Fonctionnent sur TOUTE page ═══
    'elakayCategories',       // 🔌 CATEGORIES  | Slider catégories Elakay
    'categoryItems',          // 🔌 CATEGORIES  | Slider sous-catégories
    'newProducts',            // 🔌 PRODUCTS    | Slider nouveautés
    'bestSellers',            // 🔌 PRODUCTS    | Slider meilleures ventes
    'dealTodays',             // 🔌 PRODUCTS    | Slider deals du jour
    'userView',               // 🔌 PRODUCTS    | Slider produits vus (facet API)
    'userViewGrid',           // 🔌 PRODUCTS    | Grille paginée produits vus (ProductGridPage)
    'historySearchMatrix',    // 🔌 PRODUCTS    | Matrice historique recherche
    'userViewMatrix',         // 🔌 PRODUCTS    | Matrice vues par catégorie
    'followShopUser',         // 🔌 PRODUCTS    | Matrice boutiques suivies
    'productCategoryMatrix',  // 🔌 PRODUCTS    | Catégories produits
    'followMe',               // 🔌 PRODUCTS    | Suggestion de suivi
    'productGrid',            // 🔌 PRODUCTS    | Grille produits + pagination
    'categoryProductsLoop',   // 🔌 PRODUCTS    | Boucle par catégorie (AAA)
    'productsByCategory',     // 🔌 PRODUCTS    | Produits même catégorie
    'newProductSection',      // 🔌 PRODUCTS    | Section nouveaux produits
    'historySearchMatrixGrid',       // 🔌 PRODUCTS | Toutes les cartes Search History (MatrixCardsGrid)
    'userViewMatrixGrid',            // 🔌 PRODUCTS | Toutes les cartes Viewing Activity (MatrixCardsGrid)
    'followShopUserGrid',            // 🔌 PRODUCTS | Toutes les cartes Shops You Follow (MatrixCardsGrid)

    // ═══ LAKAY_USER loader (getLakayUser admin) — Besoin: userAdmin._id ═══
    'shopCategories',         // 🔌 LAKAY_USER  | Catégories boutique admin
    'pubCategoryProd',        // 🔌 LAKAY_USER  | Pub catégorie admin
    'lakayUserSection',       // 🔌 LAKAY_USER  | Section boutique vendeur

    // ═══ SHOP_USER loader (getLakayUser shop) — Besoin: userId ═══
    'shopHeader',             // 🔌 SHOP_USER   | En-tête boutique
    'shopSliderPub',          // 🔌 SHOP_USER   | Slider pub boutique
    'shopCategoriesMatrix',   // 🔌 SHOP_USER   | Catégories boutique
    'shopPubCategoryMatrix',  // 🔌 SHOP_USER   | Pub catégorie boutique
    'shopProductGrid',        // 🔌 SHOP_USER   | Grille produits boutique

    // ═══ USER_VIEWED loader (getUserViewed) — Auto-résolu ═══
    'userViewedDirect',       // 🔌 USER_VIEWED | Produits vus (appel direct)

    // ═══ ORDERS loader (listOrders) — Besoin: token ═══
    'ordersHeader',           // 🔌 ORDERS      | En-tête commandes
    'ordersList',             // 🔌 ORDERS      | Liste commandes
    'ordersEmpty',            // 🔌 ORDERS      | État pas de commandes
    'ordersFullLayout',       // 🔌 ORDERS      | Layout commandes complet

    // ═══ CATEGORIES loader (getCategoriesByID) — Besoin: categoryId ═══
    'categoryMetadata',       // 🔌 CATEGORIES  | Metadata catégorie

    // ═══ PRODUCT_PREVIEW loader (getProductPreview) — Besoin: productId ═══
    'productUnavailable',     // 🔌 PROD_PREV   | Produit indisponible
    'productFullView',        // 🔌 PROD_PREV   | Vue complète produit
    'productViewMain',        // 🔌 PROD_PREV   | Vue principale
    'productDetailsTabs',     // 🔌 PROD_PREV   | Onglets détails
    'productImagesNote',      // 🔌 PROD_PREV   | Images note
    'productPreviewData',     // 🔌 PROD_PREV   | Données brutes preview

    // ═══ COMMENTS loader (commentProduct) — Besoin: productId ═══
    'productComments',        // 🔌 COMMENTS    | Commentaires produit
    'productCommentsModal',   // 🔌 COMMENTS    | Modal commentaires
    'productCommentsData',    // 🔌 COMMENTS    | Données commentaires

    // ═══ SEARCH loader (getProductSearch) — Skip si search vide ═══
    'productSearch',          // 🔌 SEARCH      | Grille résultats recherche

    // ═══ INVESTMENTS loader — Opportunites Elakay ═══
    'investmentProjects',     // 🔌 INVESTMENTS | Catalogue public investissement
    'investmentProject',      // 🔌 INVESTMENTS | Detail du projet clique

    // ═══ JOBS loader — Recrutement Elakay ═══
    'jobPostings',            // 🔌 JOBS | Catalogue public jobs
    'jobPosting',             // 🔌 JOBS | Detail du job clique

    // ═══ NONE (infoSource sync) — Fonctionnent via FACET_SYNC_MAP_ ═══
    'userInfoCard',           // 📋 NONE        | Carte info utilisateur
    'userButtons',            // 📋 NONE        | Boutons profil
    'userModal',              // 📋 NONE        | Modal profil
    'cartHeader',             // 📋 NONE        | En-tête panier
    'cartItemsList',          // 📋 NONE        | Liste articles
    'cartCheckout',           // 📋 NONE        | Checkout
    'cartEmpty',              // 📋 NONE        | Panier vide
    'cartFullLayout',         // 📋 NONE        | Layout panier complet
    'ordersModals',           // 📋 NONE        | Modals commandes
    'shopModals',             // 📋 NONE        | Modals boutique
];

// ─────────────────────────────────────────────────────────────────────────────
// FACETS PAR PAGE — Configurations par défaut
// ─────────────────────────────────────────────────────────────────────────────
//
// AnimationSettings peut modifier ces listes:
//   - Ajouter un facet d'une autre page
//   - Retirer un facet
//   - Réordonner les facets
//
// Le DataLoader gère automatiquement le routing vers le bon loader.
// ─────────────────────────────────────────────────────────────────────────────

export const PAGE_FACETS = {

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ HOME — Loaders: PRODUCTS + LAKAY_USER = 2 appels API              │
    // └─────────────────────────────────────────────────────────────────────┘
    HOME: [
        'elakayCategories',       // CATEGORIES
        'historySearchMatrix',    // PRODUCTS
        'shopCategories',         // LAKAY_USER
        'pubCategoryProd',        // LAKAY_USER
        'userView',               // PRODUCTS
        'userViewMatrix',         // PRODUCTS
        'newProducts',            // PRODUCTS
        'followShopUser',         // PRODUCTS
        'followMe',               // PRODUCTS
        'bestSellers',            // PRODUCTS
        'dealTodays',             // PRODUCTS
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ NEW PRODUCTS — Loaders: PRODUCTS = 1 appel API                     │
    // │ productGrid [0] consomme productsByArrival                         │
    // └─────────────────────────────────────────────────────────────────────┘
    newProducts: [
        'productGrid',            // PRODUCTS (__PRODUCTS_BASE__) — productsByArrival
        'userView',               // PRODUCTS
        'followMe',               // PRODUCTS
        'bestSellers',            // PRODUCTS
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ BEST SELLERS — Loaders: PRODUCTS + LAKAY_USER = 2 appels API       │
    // │ productGrid [0] consomme productsBySell                            │
    // └─────────────────────────────────────────────────────────────────────┘
    bestSellers: [
        'bestSellersGrid',            // PRODUCTS (__PRODUCTS_BASE__) — productsBySell
        'dealTodays',             // PRODUCTS
        'followShopUser',         // PRODUCTS
        'followMe',               // PRODUCTS
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ DEAL OF THE DAY — Loaders: PRODUCTS + LAKAY_USER = 2 appels API    │
    // │ productGrid [0] consomme dealToDayProducts                         │
    // └─────────────────────────────────────────────────────────────────────┘
    dealTodays: [
        'dealTodaysGrid',            // PRODUCTS (__PRODUCTS_BASE__) — dealToDayProducts
        'bestSellers',            // PRODUCTS
        'pubCategoryProd',        // LAKAY_USER
        'followMe',               // PRODUCTS
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ SEARCH — Loaders: SEARCH = 1 appel API (skip si search vide)       │
    // │ productGrid [0] consomme products (résultats recherche)            │
    // └─────────────────────────────────────────────────────────────────────┘
    productSearch: [
        'productSearchGrid',            // SEARCH — résultats dans products
        'historySearchMatrix',    // PRODUCTS
        'userViewMatrix',         // PRODUCTS
        'followShopUser',         // PRODUCTS
        'followMe',               // PRODUCTS
    ],

    INVESTMENTS_HOME: [
        'investmentProjects',
    ],

    INVESTMENT_DETAIL: [
        'investmentProject',
    ],

    JOBS_HOME: [
        'jobPostings',
    ],

    JOB_DETAIL: [
        'jobPosting',
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ USER VIEW — Loaders: PRODUCTS = 1 appel API                        │
    // │ userViewGrid [0] — ProductGridPage paginé, facetKey: 'userView'   │
    // │   → getProductsF(skip, limit, facet: ['userView'])                 │
    // │   → dataKey: 'userViewedProduct'                                   │
    // └─────────────────────────────────────────────────────────────────────┘
    userView: [
        'userViewGrid',           // PRODUCTS — ProductGridPage paginé, facetKey: userView
        'userViewMatrix',         // PRODUCTS
        'historySearchMatrix',    // PRODUCTS
        'followMe',               // PRODUCTS
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ "ALL CARDS" PAGES — section-level "See More" on Home                │
    // │ Same data as the matching Home *Matrix section, same cards         │
    // │ (FollowPageMatrice via MatrixCardsGrid), just a full responsive     │
    // │ grid instead of the Home Swiper.                                    │
    // └─────────────────────────────────────────────────────────────────────┘
    // Main grid first, then the 2 OTHER Home matrix sliders as companions
    // (each one's own "See More" opens its own all-cards page) — matches
    // the local DEFAULT_FACETS fallback in each page file.
    searchHistoryAllCards: [
        'historySearchMatrixGrid',
        'userViewMatrix',
        'followShopUser',
    ],

    viewingActivityAllCards: [
        'userViewMatrixGrid',
        'historySearchMatrix',
        'followShopUser',
    ],

    shopsYouFollowAllCards: [
        'followShopUserGrid',
        'historySearchMatrix',
        'userViewMatrix',
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ USER_PROFILE — Loaders: USER_VIEWED = 1 appel API                 │
    // │ + infoSource sync pour userInfo, address                           │
    // └─────────────────────────────────────────────────────────────────────┘
    USER_PROFILE: [
        'userInfoCard',           // NONE (infoSource)
        'userButtons',            // NONE (infoSource)
        'shopCategoriesMatrix',   // SHOP_USER
        'userModal',              // NONE (infoSource)
        'userView',               // USER_VIEWED
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ CART — Loaders: PRODUCTS (1 facet) = 1 appel API                  │
    // │ + infoSource sync pour cartItems                                   │
    // └─────────────────────────────────────────────────────────────────────┘
    CART: [
        'cartEmpty',              // NONE (only when the cart is empty)
        'cartFullLayout',         // NONE (infoSource.getCartItems)
        'newProducts',            // PRODUCTS
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ ORDERS — Loaders: PRODUCTS + USER_VIEWED = 2 appels               │
    // │ ordersFullLayout reste local (business logic)                      │
    // └─────────────────────────────────────────────────────────────────────┘
    ORDERS: [
        // 'ordersFullLayout',       // ORDERS
        'ordersGrid',             // ORDERS
        'productsByCategory',     // PRODUCTS
        'lakayUserSection',       // LAKAY_USER
        'userViewedDirect',       // USER_VIEWED
        'newProductSection',      // PRODUCTS
        // 'ordersModals',           // NONE
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ PRODUCT_PREVIEW — Loaders: PRODUCT_PREVIEW + PRODUCTS + COMMENTS  │
    // └─────────────────────────────────────────────────────────────────────┘
    PRODUCT_PREVIEW: [
        'productFullView',        // PRODUCT_PREVIEW
        'productsByCategory',     // PRODUCTS
        'lakayUserSection',       // LAKAY_USER
        'productComments',        // COMMENTS
        'productImagesNote',      // PRODUCT_PREVIEW
        'productCommentsModal',   // COMMENTS
        'newProductSection',      // PRODUCTS
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ SHOP_USER — Loaders: SHOP_USER = 1 appel API                      │
    // └─────────────────────────────────────────────────────────────────────┘
    SHOP_USER: [
        'shopHeader',             // SHOP_USER
        'shopSliderPub',          // SHOP_USER
        'shopCategoriesMatrix',   // SHOP_USER
        'shopPubCategoryMatrix',  // SHOP_USER
        'shopProductGrid',        // SHOP_USER
        'shopModals',             // NONE
    ],

    PRODUCT_EDIT: [
        'productFullView',
        'productImagesNote',
    ],

    // ┌─────────────────────────────────────────────────────────────────────┐
    // │ PRODUCT CATALOG — AAA/AAB/AAC                                      │
    // │ PEPCData détermine quel array de facets utiliser                   │
    // │ Loaders: PRODUCTS + LAKAY_USER + CATEGORIES                        │
    // └─────────────────────────────────────────────────────────────────────┘
    AAA: [
        'followShopUser',
        'productCategory',
        'dealTodays',
        'newProducts',
        'shopCategories',
        'followMe',
        'bestSellers',
        'pubCategoryProd',
    ],

    AAB: [
        'categoryItems',
        'followShopUser',
        'productGrid',
        'pubCategoryProd',
        'followMe',
        'dealTodays',
        'bestSellers',
    ],

    AAC: [
        'productCategoryMatrix',
        'historySearchMatrix',
        'productGrid',
        'followMe',
        'followShopUser',
        'dealTodays',
        'pubCategoryProd',
        'bestSellers',
    ],

    CATEGORIES: [
        'elakayCategories',
        'categoryItems',
        'shopCategories',
        'productCategoryMatrix',
        'pubCategoryProd',
    ],

    // ═══ DEBUG / PREVIEW ═══
    DEFAULT_ALL: ALL_FACETS,
};

// ─── CATEGORY_FACETS helper ─────────────────────────────────────────────────
export const CATEGORY_FACETS = {
    AAA: PAGE_FACETS.AAA,
    AAB: PAGE_FACETS.AAB,
    AAC: PAGE_FACETS.AAC,
};

// ═══════════════════════════════════════════════════════════════════════════
// FACET_SYNC_MAP_ — infoSource → pageData pour les sections NONE
// ═══════════════════════════════════════════════════════════════════════════
//
// Les 10 sections NONE n'ont pas d'API. Leurs données viennent de infoSource.
// Ce map définit comment sync:
//   getInfoSourceUpdates_(facets, infoSource) → { dataKey: value }
//
// Quand une section NONE est mise sur une page qui n'a pas la donnée
// correspondante dans infoSource → value = null → shouldRenderSection = false
// → section pas affichée. C'est le comportement universel attendu.
// ═══════════════════════════════════════════════════════════════════════════

export const FACET_SYNC_MAP = {
    // ── User Profile ──
    userInfoCard:   { dataKey: 'userInfo',   getter: (info) => info?.userInfo },
    userButtons:    { dataKey: 'address',    getter: (info) => ({ address: info?.address, phoneUser: info?.phoneUser }) },
    userModal:      { dataKey: 'userInfo',   getter: (info) => info?.userInfo },

    // ── Cart ──
    cartHeader:     { dataKey: 'cartItems',  getter: (info) => Array.isArray(info?.getCartItems) ? info.getCartItems : (Array.isArray(info?.cartItems) ? info.cartItems : undefined) },
    cartItemsList:  { dataKey: 'cartItems',  getter: (info) => Array.isArray(info?.getCartItems) ? info.getCartItems : (Array.isArray(info?.cartItems) ? info.cartItems : undefined) },
    cartCheckout:   { dataKey: 'cartItems',  getter: (info) => Array.isArray(info?.getCartItems) ? info.getCartItems : (Array.isArray(info?.cartItems) ? info.cartItems : undefined) },
    cartEmpty:      { dataKey: 'cartItems',  getter: (info) => Array.isArray(info?.getCartItems) ? info.getCartItems : (Array.isArray(info?.cartItems) ? info.cartItems : undefined) },
    cartFullLayout: { dataKey: 'cartItems',  getter: (info) => Array.isArray(info?.getCartItems) ? info.getCartItems : (Array.isArray(info?.cartItems) ? info.cartItems : undefined) },

    // ── Modals (UI state, toujours affichés) ──
    ordersModals:   { dataKey: 'modalsState', getter: () => ({}) },
    shopModals:     { dataKey: 'shopModalsState', getter: () => ({}) },

    // ── Sections API qui ont aussi un fallback infoSource ──
    // (utilisé quand la page a déjà les données dans infoSource)
    elakayCategories:   { dataKey: 'elakayCategories',  getter: (info) => info?.elakayCategories },
    ordersFullLayout:   { dataKey: 'orders',            getter: (info) => info?.orders },
    ordersEmpty:        { dataKey: 'orders',            getter: (info) => info?.orders },
    ordersHeader:       { dataKey: 'orders',            getter: (info) => info?.orders },
    ordersList:         { dataKey: 'orders',            getter: (info) => info?.orders },
    productFullView:    { dataKey: 'product',           getter: (info) => info?.product },
    productViewMain:    { dataKey: 'product',           getter: (info) => info?.product },
    productDetailsTabs: { dataKey: 'product',           getter: (info) => info?.product },
    productImagesNote:  { dataKey: 'product',           getter: (info) => info?.product },
    productUnavailable: { dataKey: 'itemUnAvailable',   getter: (info) => info?.itemUnAvailable },
    shopHeader:         { dataKey: 'shopOwner',         getter: (info) => info?.shopOwner },
};

// ─────────────────────────────────────────────────────────────────────────────
// HELPERS
// ─────────────────────────────────────────────────────────────────────────────

/**
 * Sync infoSource → pageData pour les facets donnés.
 * 
 * Usage dans useEffect de chaque page:
 *   const updates = getInfoSourceUpdates_(facets, infoSource);
 *   if (Object.keys(updates).length > 0) mergePageData(updates);
 * 
 * Les sections API qui n'ont PAS d'entrée dans FACET_SYNC_MAP_ sont ignorées
 * (elles reçoivent leurs données uniquement via DataLoader).
 */
export const getInfoSourceUpdates = (facets, infoSource) => {
    if (!facets || !infoSource) return {};

    const updates = {};
    const processed = new Set();

    facets.forEach(facetId => {
        const syncConfig = FACET_SYNC_MAP[facetId];
        if (!syncConfig) return;
        if (processed.has(syncConfig.dataKey)) return;

        const value = syncConfig.getter(infoSource);
        if (value !== undefined && value !== null) {
            updates[syncConfig.dataKey] = value;
            processed.add(syncConfig.dataKey);
        }
    });
    return updates;
};

/**
 * Retourne les dataKeys uniques qui nécessitent un sync depuis infoSource.
 */
export const getInfoSourceDeps = (facets) => {
    if (!facets) return [];
    const deps = new Set();
    facets.forEach(facetId => {
        const syncConfig = FACET_SYNC_MAP[facetId];
        if (syncConfig) deps.add(syncConfig.dataKey);
    });
    return [...deps];
};

export default PAGE_FACETS;
